<template>
  <!-- RN-168: las acciones de un concepto en un menú ⋮ al final de la fila.
       Reemplaza a la ✕ que sólo desactivaba. -->
  <div v-if="opciones.length" ref="raiz" class="cam" data-test="menu-concepto">
    <button
      type="button" class="vx-btn vx-btn-sm cam-boton"
      :aria-expanded="abierto" aria-haspopup="menu"
      :aria-label="`Acciones de ${concepto.descripcion}`"
      data-test="btn-menu-concepto"
      @click="abierto = !abierto"
    >
      <i class="bi bi-three-dots-vertical"></i>
    </button>
    <ul v-if="abierto" class="cam-lista" role="menu">
      <li v-for="o in opciones" :key="o" role="none">
        <button
          type="button" role="menuitem" class="cam-opcion"
          :class="{ 'cam-peligro': o === 'eliminar' }"
          :data-test="`opcion-${o}`"
          @click="elegir(o)"
        >
          <i class="bi" :class="ICONOS[o]"></i>
          {{ TEXTOS[o] }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
// El estado se maneja con un `ref` y no con `data-bs-toggle="dropdown"`: el
// data-api de dropdowns de Bootstrap NO está activo en esta app (verificado y
// documentado en `ProductosView.vue`). Un `data-bs-toggle` no abriría nada.
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { opcionesDelConcepto } from '@/utils/conceptoAcciones.mjs'

const props = defineProps({
  concepto: { type: Object, required: true },
  puedeEsquemas: { type: Boolean, default: false },
  puedeCargos: { type: Boolean, default: false }
})
const emit = defineEmits(['accion'])

const TEXTOS = { editar: 'Editar', desactivar: 'Desactivar', reactivar: 'Reactivar', eliminar: 'Eliminar' }
const ICONOS = { editar: 'bi-pencil', desactivar: 'bi-pause-circle', reactivar: 'bi-play-circle', eliminar: 'bi-trash' }

const abierto = ref(false)
const raiz = ref(null)

const opciones = computed(() => opcionesDelConcepto(props.concepto, {
  puedeEsquemas: props.puedeEsquemas, puedeCargos: props.puedeCargos
}))

function elegir (opcion) {
  abierto.value = false
  emit('accion', opcion, props.concepto)
}

const alClicAfuera = (e) => {
  if (abierto.value && raiz.value && !raiz.value.contains(e.target)) abierto.value = false
}
const alTeclear = (e) => { if (e.key === 'Escape') abierto.value = false }

onMounted(() => {
  document.addEventListener('click', alClicAfuera)
  document.addEventListener('keydown', alTeclear)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', alClicAfuera)
  document.removeEventListener('keydown', alTeclear)
})
</script>

<style scoped>
.cam { position: relative; display: inline-block; }
.cam-boton { padding: 0 8px; }
.cam-lista {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 30;
  min-width: 168px;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: var(--vx-panel);
  border: 1px solid var(--vx-borde-fuerte);
  border-radius: var(--vx-radio-sm);
  box-shadow: var(--vx-sombra);
}
.cam-opcion {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  font-size: 13px;
  text-align: left;
  color: var(--vx-ink);
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}
.cam-opcion:hover { background: var(--vx-acento-tinte); }
.cam-peligro { color: #b91c1c; }
.cam-peligro:hover { background: rgba(185, 28, 28, 0.08); }
</style>
